/* @flow */
import * as React from 'react';
import { graphql } from 'react-apollo';

import adminOrgAdminsViewQuery from 'admin/queries/adminOrgAdminsViewQuery.gql';
import AdminAdminsView from 'admin/components/AdminAdminsView';
import ErrorReporter from 'app/components/ErrorReporter';
import LoadingIndicator from 'components/LoadingIndicator';

type Props = {
  data: ReactApolloData<adminOrgAdminsViewQuery>,
  orgId: number,
};

function AdminOrgAdminsView(props: Props) {
  const { data } = props;

  if (data && data.loading) {
    return <LoadingIndicator height={40} size="small" />;
  }

  const organization = data ? data.organizations[0] : null;

  if (!organization) {
    return <ErrorReporter error="tried to render AdminOrgAdminsView without an organization" />;
  }

  const organizationInfo = { id: organization.id, name: organization.name };
  const { type } = organization;

  // Insert org id into verification objects
  const admins = organization.admins.map(admin => ({
    ...admin,
    organizationId: organization.id,
    organizationName: organization.name,
  }));

  return (
    <div className="AdminOrgsAdminView">
      <AdminAdminsView
        admins={admins}
        organizationType={type || 'School'}
        organizations={[organizationInfo]}
      />
    </div>
  );
}

const withData = graphql(adminOrgAdminsViewQuery, {
  options: ({ orgId }) => ({
    variables: {
      organizationId: orgId,
    },
  }),
});

export { AdminOrgAdminsView };
export default withData(AdminOrgAdminsView);
